import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2676246475 from "../../../../../packages/component/src/components/timeline/demo/demo1.js?loadDemo";
import legacyImportDemo_1855493352 from "../../../../../packages/component/src/components/timeline/demo/demo2.js?loadDemo";
import legacyImportDemo_2245036809 from "../../../../../packages/component/src/components/timeline/demo/demo3.js?loadDemo";
import legacyImportDemo_335453742 from "../../../../../packages/component/src/components/timeline/demo/demo4.js?loadDemo";
import legacyImportDemo_1537173839 from "../../../../../packages/component/src/components/timeline/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2676246475,
  legacyImportDemo_1855493352,
  legacyImportDemo_2245036809,
  legacyImportDemo_335453742,
  legacyImportDemo_1537173839,
  React
};